import { Navigate } from "react-router-dom";
import { ROUTES } from "../routes";
import { useAuth } from "./AuthContext";
import { AuthLoading } from "./AuthLoading";

export default function ProtectedRoute({ children }) {
    const { auth } = useAuth();

    // Still loading — don’t redirect yet
    if (auth === undefined || auth === null) {
        return <AuthLoading />;
    }

    // Not authenticated? Redirect to login
    if (auth.meta?.is_authenticated === false) {
        return <Navigate to={ROUTES.ACCOUNT.LOGIN} replace />;
    }

    // Authenticated
    return children;
}
